import React, { useState, useContext, useEffect } from 'react'
import { Link } from "react-router-dom";
import { global } from '../../Context/Context';
import { toast } from 'react-toastify'
import axiosInstance from '../../config/axiosInterceptor';

const ManageUserBadge = () => {
    const baseUrl = process.env.REACT_APP_BASEURL1;
    const { viewUserBadge, viewUserBadges } = useContext(global)
    const [currentPage, setCurrentPage] = useState(1);
    const [entriesPerPage, setEntriesPerPage] = useState(5);

    const [de, setDe] = useState();
    useEffect(() => {
        viewUserBadge()
    }, [de])

    const indexOfLastUser = currentPage * entriesPerPage;
    const indexOfFirstUser = indexOfLastUser - entriesPerPage;
    const currentUsers = Array.isArray(viewUserBadges) ? viewUserBadges.slice(indexOfFirstUser, indexOfLastUser) : [];

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const totalPages = Math.ceil((viewUserBadges?.length || 0) / entriesPerPage);

    const renderPageNumbers = () => {
        const pageNumbers = [];
        const startPage = Math.max(1, currentPage - 2);
        const endPage = Math.min(totalPages, currentPage + 2);

        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(
                <li key={i} className={`page-item ${currentPage === i ? 'active' : ''}`}>
                    <button onClick={() => paginate(i)} className="page-link">
                        {i}
                    </button>
                </li>
            );
        }

        return pageNumbers;
    };

    const handleDeleteUserBadge = async (id) => {
        await axiosInstance.delete(`${process.env.REACT_APP_BASEURL5}/admin/userBadge/deleteuserbadge/${id}`).then((res) => {
            if (res.data.success === 1) {
                toast.success(res.data.message)
                setDe(1);
            } else {
                toast.error(res.data.message)
            }
        }).catch((e) => toast.error(e.message));
    };

    return (
        <>
            <section className="content-header">
                <h1>Manage User Badge</h1>
                <ol className="breadcrumb">
                    <li><Link to="/admin"><i className="fa fa-dashboard" /> Home</Link></li>
                    <li className="active">Manage User Badge</li>
                </ol>
            </section>
            <section className="content">
                <div className="row">
                    <div className="col-xs-12">
                        <div className="box">
                            <div className="box-header">
                                <h3 className="box-title"><Link to="/admin/addUserBadge" style={{ fontSize: '14px' }} className="btn btn-block btn-success btn-xs">Add User Badge</Link></h3>
                            </div>
                            <div className="box-body">
                                <div className="row " style={{ padding: '16px 0px' }}>
                                    <div className="entries-per-page col-md-6 ">
                                        <label htmlFor="entries">Entries per page:</label>
                                        <select id="entries" value={entriesPerPage} onChange={(e) => setEntriesPerPage(parseInt(e.target.value))}>
                                            <option value="5">5</option>
                                            <option value="10">10</option>
                                            <option value="20">20</option>
                                            <option value="50">50</option>
                                        </select>
                                    </div>
                                </div>
                                <table id="example1" className="table table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            <th>Sr.</th>
                                            <th>Title</th>
                                            <th>Type</th>
                                            <th>Image</th>
                                            <th>Price</th>
                                            <th>Valid For</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody id="ts">
                                        {
                                            currentUsers.map((item, index) => {
                                                let i = indexOfFirstUser + index + 1;
                                                return (
                                                    <tr key={item._id}>
                                                        <td>{i}</td>
                                                        <td>{item.title}</td>
                                                        <td>{item.type}</td>
                                                        <td><img src={item.image} style={{ width: '80px', height: '70px' }} alt="" /></td>
                                                        <td>{item.price}</td>
                                                        <td>{item.valid}</td>
                                                        <td>
                                                            <ul className="admin-action btn btn-default" style={{ backgroundColor: '#f4f4f4', color: '#fff !important' }}>
                                                                <li className="dropdown">
                                                                    <a className="dropdown-toggle" style={{ color: 'black' }} data-toggle="dropdown" href="#" aria-expanded="false">
                                                                        Action
                                                                    </a>
                                                                    <ul className="dropdown-menu dropdown-menu-right">
                                                                        <li role="presentation">
                                                                            <Link role="menuitem" tabIndex={-1} to={`/admin/editUserBadge?id=${item._id}`}>Edit</Link>
                                                                        </li>
                                                                        <li role="presentation">
                                                                            <Link role="menuitem" tabIndex={-1} onClick={() => {
                                                                                handleDeleteUserBadge(item._id);
                                                                            }}>Delete</Link>
                                                                        </li>
                                                                    </ul>
                                                                </li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                                <div className="row">
                                    <div className="col-md-5">
                                        <ul className="pagination">
                                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                <button
                                                    onClick={() => paginate(currentPage - 1)}
                                                    className="page-link dfsdfasdf"
                                                    disabled={currentPage === 1}
                                                >
                                                    Previous
                                                </button>
                                            </li>
                                            {currentPage > 2 && <li className="page-item disabled"></li>}
                                            {renderPageNumbers()}
                                            {currentPage < totalPages - 1 && <li className="page-item disabled"></li>}
                                            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                <button
                                                    onClick={() => paginate(currentPage + 1)}
                                                    className="page-link dfsdfasdf"
                                                    disabled={currentPage === totalPages}
                                                >
                                                    Next
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="col-md-5">
                                        <div className="total-entries" style={{ float: "right", marginTop: '20px' }}>
                                            Total entries: <b>{viewUserBadges?.length || 0}</b>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default ManageUserBadge
